import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'uui-input-description',
  styleUrl: 'uui-input-description.css',
  shadow: true
})
export class UUIInputDescription {
  @Prop() width: string = '100%';
  @Prop({ mutable: true, reflect: true }) show: boolean = true;
  @Prop({ mutable: true, reflect: true }) error: boolean = false;

  render() {
    if (!this.show) return null;

    return (
      <Host>
        <div><slot /></div>
      </Host>
    );
  }
}
